

const ContactSection = () => {
  return (
    <section id="contatti" className="py-4 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-8 animate-fade-in-up">
          <h2 className="mb-4 text-primary uppercase text-2xl md:text-4xl text-center" style={{ fontFamily: 'Verdana, sans-serif' }}>Vieni a trovarci</h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto" style={{ fontFamily: 'Verdana, sans-serif' }}>
            Siamo a Magione, in Viale Umbria 21. Ti aspettiamo!
          </p>
        </div>

        <div className="max-w-4xl mx-auto animate-fade-in-up">
          {/* Map */}
          <div className="rounded-2xl overflow-hidden shadow-[var(--shadow-large)] h-[500px] lg:h-[600px]">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d11724.936859385967!2d12.2126753!3d43.1441941!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x132c03b77e5a02cd%3A0x28d3d21dfae7e3ff!2snegozio%20prodotti%20zootecnici%20pietro%20rubini!5e0!3m2!1sit!2sit!4v1234567890"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Mappa Mangimi Rubini"
            />
          </div>

          {/* Navigation Button */}
          <div className="mt-6 text-center">
            <a
              href="https://www.google.com/maps/dir/?api=1&destination=Viale+Umbria+21,+06063+Magione+PG"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block btn-cta px-8 py-4 rounded-xl font-semibold text-lg shadow-md hover:shadow-lg transition-all"
            >
              Imposta Navigatore
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
